import React from 'react';
import { Icon } from './Icon.jsx';

const PRESETS = {
  member: { icon: 'lock', label: '会员专享' },
  free: { icon: null, label: '免费收听' },
  video: { icon: 'smart_display', label: '视频版' },
  new: { icon: null, label: '新' },
  neutral: { icon: null, label: '' },
};

/** Episode / content marker. `member` and `free` are the two required episode states. */
export function Badge({ variant = 'neutral', icon, className = '', children, ...rest }) {
  const preset = PRESETS[variant] || PRESETS.neutral;
  const glyph = icon !== undefined ? icon : preset.icon;
  return (
    <span className={`bjl-badge bjl-badge--${variant} ${className}`} {...rest}>
      {glyph ? <Icon name={glyph} fill /> : null}
      {children != null ? children : preset.label}
    </span>
  );
}
